import { render, staticRenderFns } from "./ObjectsListItem.vue?vue&type=template&id=12a85e3b&scoped=true&"
import script from "./ObjectsListItem.vue?vue&type=script&lang=js&"
export * from "./ObjectsListItem.vue?vue&type=script&lang=js&"
import style0 from "./ObjectsListItem.vue?vue&type=style&index=0&id=12a85e3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a85e3b",
  null
  
)

export default component.exports